/* =============================================================
   Major9 – product highlighter voor blogartikelen
   -------------------------------------------------------------
   Markeert producttitels (platen én boeken) in je artikeltekst in
   dezelfde stijl als je glossary (stippellijn + icoontje), maar met
   een ander icoon en een hover-/tap-kaartje met cover, prijs,
   voorraad en een knop naar de productpagina.

   Werkt client-side. De productlijst komt via Shopify's /products.json
   en wordt per sessie gecachet, dus nieuwe voorraad doet vanzelf mee.

   INSTALLATIE: zie onderaan dit bestand.
   ============================================================= */
(function () {
  'use strict';

  /* ====== CONFIG ====== */
  var CONFIG = {
    // Zelfde container als je glossary, plus een paar fallbacks.
    articleSelector: '.article-content__wrapper, .article-template__content, .rte',
    productsEndpoint: '/products.json',
    maxLinksPerArticle: 20,
    minTitleLength: 5,            // genormaliseerde minimumlengte (verlaag voor korte titels als "Tyla")
    linkFirstOccurrenceOnly: true,
    cacheMinutes: 30,
    locale: 'nl-NL',
    currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
    denylist: ['live', 'one', 'hits', 'love'],
    aliases: {},
    manualProducts: []
  };

  /* ====== Stijl — afgestemd op je glossary ====== */
  var DISC = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2'%3E%3Ccircle cx='12' cy='12' r='9'/%3E%3Ccircle cx='12' cy='12' r='4.6'/%3E%3Ccircle cx='12' cy='12' r='1' fill='black' stroke='none'/%3E%3C/svg%3E\")";
  var BOOK = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2' stroke-linejoin='round'%3E%3Cpath d='M5 4h11a1 1 0 0 1 1 1v15H6a1 1 0 0 1-1-1z'/%3E%3Cpath d='M17 16H6'/%3E%3C/svg%3E\")";

  var CSS = `
  .m9-term{
    border-bottom:1px dotted rgb(var(--color-foreground) / 0.45);
    cursor:pointer; color:inherit; text-decoration:none;
  }
  .m9-term::after{
    content:""; display:inline-block;
    width:0.85em; height:0.85em; margin-left:0.2em; vertical-align:0.04em;
    background-color:currentColor;
    opacity:0.85;                                /* feller dan de glossary (die staat op 0.5) */
    transition:opacity .12s ease;
    -webkit-mask:var(--m9-ic) center / contain no-repeat;
            mask:var(--m9-ic) center / contain no-repeat;
  }
  .m9-disc{--m9-ic:${DISC}}
  .m9-book{--m9-ic:${BOOK}}
  .m9-term:hover::after,.m9-term:focus-visible::after{opacity:1}
  .m9-term:focus-visible{outline:2px solid rgb(var(--color-foreground) / 0.4);outline-offset:2px;border-radius:2px}

  .m9-card{
    position:absolute; z-index:9999; width:250px;
    background:rgb(var(--color-background)); color:rgb(var(--color-foreground));
    border:1px solid rgb(var(--color-foreground) / 0.15); border-radius:8px;
    padding:12px; box-shadow:0 6px 24px rgb(0 0 0 / 0.18);
    font-size:1.3rem; line-height:1.45; letter-spacing:0; text-transform:none;
    display:none;
  }
  .m9-card.m9-show{display:block}
  .m9-row{display:flex; gap:10px; align-items:center}
  .m9-cover{width:50px; height:50px; border-radius:6px; object-fit:cover; flex:none;
    background:rgb(var(--color-foreground) / 0.08); color:rgb(var(--color-foreground) / 0.7);
    display:flex; align-items:center; justify-content:center; font-weight:600; font-size:1.2rem}
  .m9-meta{min-width:0}
  .m9-title{font-weight:600; margin:0}
  .m9-sub{color:rgb(var(--color-foreground) / 0.6); font-size:1.2rem; margin:2px 0 0}
  .m9-pricerow{display:flex; justify-content:space-between; align-items:center; margin:10px 0 9px}
  .m9-price{font-weight:600}
  .m9-stock{font-size:1.15rem}
  .m9-in{color:#1a8a4e}.m9-out{color:rgb(var(--color-foreground) / 0.5)}
  .m9-btn{display:block; text-align:center; padding:8px 10px; border-radius:6px;
    background:rgb(var(--color-foreground)); color:rgb(var(--color-background));
    text-decoration:none; font-weight:500; font-size:1.2rem}
  `;

  /* ====== Hulpfuncties ====== */
  function isBook(p){
    var t=((p.type||'')+' '+(p.title||'')).toLowerCase();
    return /boek|book|magazine|tijdschrift/.test(t);
  }
  function money(price){
    var n=parseFloat(price);
    if(isNaN(n))return '';
    try{return new Intl.NumberFormat(CONFIG.locale,{style:'currency',currency:CONFIG.currency}).format(n);}
    catch(e){return '\u20ac'+n.toFixed(2);}
  }
  function buildNorm(text){
    var norm='',map=[],prevSpace=true;
    for(var i=0;i<text.length;i++){
      var low=text[i].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
      for(var k=0;k<low.length;k++){
        var c=low[k];
        if(/[a-z0-9]/.test(c)){norm+=c;map.push(i);prevSpace=false;}
        else if(!prevSpace){norm+=' ';map.push(i);prevSpace=true;}
      }
    }
    while(norm.endsWith(' ')){norm=norm.slice(0,-1);map.pop();}
    return {norm:norm,map:map};
  }
  function normalizeTitle(str){return buildNorm(str).norm;}
  function findWord(hay,needle){
    var from=0,i;
    while((i=hay.indexOf(needle,from))>-1){
      var before=i===0?' ':hay[i-1];
      var after=(i+needle.length>=hay.length)?' ':hay[i+needle.length];
      if(before===' '&&after===' ')return i;
      from=i+1;
    }
    return -1;
  }

  /* ====== Productlijst laden (sessie-cache) ====== */
  function loadProducts(){
    try{
      var cached=sessionStorage.getItem('m9_products');
      if(cached){var o=JSON.parse(cached);if(Date.now()-o.t<CONFIG.cacheMinutes*60000)return Promise.resolve(o.items);}
    }catch(e){}
    var items=[];
    function fetchPage(page){
      return fetch(CONFIG.productsEndpoint+'?limit=250&page='+page,{headers:{Accept:'application/json'}})
        .then(function(r){return r.ok?r.json():{products:[]};})
        .then(function(data){
          var list=(data&&data.products)||[];
          list.forEach(function(p){
            var v=p.variants||[];
            items.push({title:p.title,handle:p.handle,type:p.product_type||'',vendor:p.vendor||'',
              price:v.length?v[0].price:null,available:v.some(function(x){return x.available;}),
              image:(p.images&&p.images[0]&&p.images[0].src)||(p.image&&p.image.src)||''});
          });
          if(list.length===250&&page<20)return fetchPage(page+1);
        });
    }
    return fetchPage(1).then(function(){
      CONFIG.manualProducts.forEach(function(p){items.push(p);});
      try{sessionStorage.setItem('m9_products',JSON.stringify({t:Date.now(),items:items}));}catch(e){}
      return items;
    }).catch(function(){return CONFIG.manualProducts.slice();});
  }

  /* ====== Lookup ====== */
  function buildLookup(products){
    var lookup={},byHandle={};
    products.forEach(function(p){byHandle[p.handle]=p;});
    products.forEach(function(p){
      var nt=normalizeTitle(p.title);
      if(nt.length<CONFIG.minTitleLength)return;
      if(CONFIG.denylist.indexOf(nt)>-1)return;
      if(!lookup[nt])lookup[nt]=p;
    });
    Object.keys(CONFIG.aliases).forEach(function(a){
      var h=CONFIG.aliases[a]; if(byHandle[h])lookup[normalizeTitle(a)]=byHandle[h];
    });
    var titles=Object.keys(lookup).sort(function(a,b){return b.length-a.length;});
    return {lookup:lookup,titles:titles};
  }

  /* ====== Scannen en wikkelen ====== */
  function getTextNodes(root){
    var skip={A:1,BUTTON:1,SCRIPT:1,STYLE:1,CODE:1,PRE:1,H1:1,H2:1,H3:1,H4:1,NOSCRIPT:1};
    var walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,{
      acceptNode:function(n){
        if(!n.nodeValue||!n.nodeValue.trim())return NodeFilter.FILTER_REJECT;
        var p=n.parentNode;
        while(p&&p!==root){
          if(skip[p.nodeName]||(p.classList&&(p.classList.contains('m9-term')||p.classList.contains('jargon'))))
            return NodeFilter.FILTER_REJECT;
          p=p.parentNode;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes=[],x; while((x=walker.nextNode()))nodes.push(x); return nodes;
  }
  function buildTerm(label,prod){
    var span=document.createElement('span');
    span.className='m9-term '+(isBook(prod)?'m9-book':'m9-disc');
    span.textContent=label;
    span.setAttribute('tabindex','0');
    span.setAttribute('role','link');
    span._m9=prod;
    return span;
  }
  function processNode(node,data,state){
    if(state.count>=CONFIG.maxLinksPerArticle)return;
    var text=node.nodeValue, nb=buildNorm(text), best=null;
    for(var t=0;t<data.titles.length;t++){
      var nt=data.titles[t];
      if(CONFIG.linkFirstOccurrenceOnly&&state.used[data.lookup[nt].handle])continue;
      var idx=findWord(nb.norm,nt);
      if(idx>-1&&(best===null||idx<best.idx))best={idx:idx,nt:nt};
    }
    if(!best)return;
    var p=best.idx,len=best.nt.length,startOrig=nb.map[p],endOrig=nb.map[p+len-1]+1,prod=data.lookup[best.nt];
    var after=node.splitText(startOrig);
    var rest=after.splitText(endOrig-startOrig);
    var span=buildTerm(text.substring(startOrig,endOrig),prod);
    after.parentNode.replaceChild(span,after);
    state.used[prod.handle]=true; state.count++;
    processNode(rest,data,state);
  }

  /* ====== Kaartje ====== */
  var card,hideTimer;
  function ensureCard(){
    if(card)return;
    card=document.createElement('div'); card.className='m9-card'; document.body.appendChild(card);
    card.addEventListener('mouseenter',function(){clearTimeout(hideTimer);});
    card.addEventListener('mouseleave',hideCard);
  }
  function fillCard(p){
    var cover=p.image?'<img class="m9-cover" src="'+p.image+'" alt="">'
      :'<div class="m9-cover">'+(p.title||'?').substring(0,2).toUpperCase()+'</div>';
    var stock=p.available?'<span class="m9-stock m9-in">op voorraad</span>':'<span class="m9-stock m9-out">uitverkocht</span>';
    var label=isBook(p)?'Bekijk boek':'Bekijk plaat';
    card.innerHTML='<div class="m9-row">'+cover+
      '<div class="m9-meta"><p class="m9-title">'+p.title+'</p>'+
      '<p class="m9-sub">'+(p.vendor||p.type||'')+'</p></div></div>'+
      '<div class="m9-pricerow"><span class="m9-price">'+money(p.price)+'</span>'+stock+'</div>'+
      '<a class="m9-btn" href="/products/'+p.handle+'">'+label+' \u2192</a>';
  }
  function showCard(term){
    ensureCard(); clearTimeout(hideTimer); fillCard(term._m9); card.classList.add('m9-show');
    var r=term.getBoundingClientRect();
    var max=window.scrollX+document.documentElement.clientWidth-card.offsetWidth-8;
    card.style.top=(window.scrollY+r.bottom+6)+'px';
    card.style.left=Math.max(8,Math.min(window.scrollX+r.left,max))+'px';
  }
  function hideCard(){hideTimer=setTimeout(function(){if(card)card.classList.remove('m9-show');},120);}
  function wireEvents(){
    document.addEventListener('mouseover',function(e){var t=e.target.closest&&e.target.closest('.m9-term');if(t)showCard(t);});
    document.addEventListener('mouseout',function(e){if(e.target.closest&&e.target.closest('.m9-term'))hideCard();});
    document.addEventListener('click',function(e){var t=e.target.closest&&e.target.closest('.m9-term');if(t){e.preventDefault();showCard(t);}else if(card)card.classList.remove('m9-show');});
    document.addEventListener('focusin',function(e){var t=e.target.closest&&e.target.closest('.m9-term');if(t)showCard(t);});
  }

  /* ====== Start ====== */
  function init(){
    var root=document.querySelector(CONFIG.articleSelector);
    if(!root)return;
    var style=document.createElement('style'); style.textContent=CSS; document.head.appendChild(style);
    loadProducts().then(function(products){
      if(!products.length){console.warn('[Major9] Geen producten geladen. Staat /products.json aan?');return;}
      var data=buildLookup(products), state={used:{},count:0};
      getTextNodes(root).forEach(function(n){if(n.parentNode)processNode(n,data,state);});
      wireEvents();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();

/* =============================================================
   INSTALLATIE staat ongewijzigd: bestand in Assets, en in
   theme.liquid vóór </body>:
     {% if template contains 'article' %}
       <script src="{{ 'major9-product-links.js' | asset_url }}" defer></script>
     {% endif %}
   ============================================================= */